module.exports = __webpack_public_path__ + "assets/img/1601589449039_.pic_hd.57e78712.jpg";